import React from 'react'
import Grid from '@mui/material/Grid2'
import schema from './schema.json'
import notelist from './notelist.json'
import Divider from '@/components/divider/Divider'

const Members: React.FC = () => {
  return (
    <Grid
      container
      direction="column"
      columnSpacing={2}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      marginBottom="50px"
    >
      <Grid size={10}>
        <h1>För våra musikanter</h1>
        <p>Här finner du allt som är relevant för dig som är medlem i kåren.</p>
      </Grid>
      <Grid size={10}>
        <h2>Musikkårens repetitions- och spelprogram för 2025</h2>
      </Grid>
      <Grid
        container
        direction="row"
        size={{ xs: 11, md: 8 }}
        justifyContent="center"
        alignItems="flex-start"
        textAlign="start"
      >
        <Grid container size={{ xs: 11, md: 6 }} offset={2} textAlign="start">
          <p>
            Förklaring till programmets utformning:
            <br />
            Vanlig text = vanlig repetition
            <br />
            <u>Understruken text = viktig repetition</u>
            <br />
            <b>Fet text = konsert</b>
            <br />
            (OBS! Med reservation om kommande ändringar)
          </p>
        </Grid>
        <Grid container offset={2}>
          {schema.months.map((month, index) => (
            <Grid key={index} size={{ xs: 11, md: 6 }} textAlign="start">
              <h3>{month.month}</h3>
              <table>
                {month.days.map((day, index) => (
                  <tr key={index} style={{ fontWeight: 'normal' }}>
                    <th style={{ fontWeight: 'normal', paddingRight: '2em' }}>
                      {day.type ? (
                        <>
                          {day.type === 'important' ? (
                            <u>{day.day}</u>
                          ) : (
                            <b>{day.day}</b>
                          )}
                        </>
                      ) : (
                        <>{day.day}</>
                      )}
                    </th>
                    <th style={{ fontWeight: 'normal', textAlign: 'start' }}>
                      {day.type ? (
                        <>
                          {day.type === 'important' ? (
                            <u>{day.text}</u>
                          ) : (
                            <b>{day.text}</b>
                          )}
                        </>
                      ) : (
                        <>{day.text}</>
                      )}
                    </th>
                  </tr>
                ))}
              </table>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Divider size={{ xs: 11, md: 10 }} />
      <Grid size={10}>
        <h2>Låtlista</h2>
        <p>
          Dessa låtar ska du ha i 4 delar i din mapp (Konsertlåtar, Vårlåtar,
          Jullåtar, Gatukonsert)
        </p>
      </Grid>
      <Grid container offset={2}>
        {notelist.types.map((month, index) => (
          <Grid key={index} size={{ xs: 11, md: 6 }} textAlign="start">
            <h3>{month.type}</h3>
            <ul>
              {month.songs.sort().map((song, index) => (
                <li key={index}>{song}</li>
              ))}
            </ul>
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}

export default Members
